const hourBasedStartOptions = [
    {
        value: 0,
        text: '00:00 Hours'
    },
/*     {
        value: 1,
        text: '01:00 Hours'
    }, */
    {
        value: 2,
        text: '02:00 Hours'
    },
/*     {
        value: 3,
        text: '03:00 Hours'
    }, */
    {
        value: 4,
        text: '04:00 Hours'
    },
/*     {
        value: 5,
        text: '05:00 Hours'
    }, */
    {
        value: 6,
        text: '06:00 Hours'
    },
/*     {
        value: 7,
        text: '07:00 Hours'
    }, */
    {
        value: 8,
        text: '08:00 Hours'
    },
/*     {
        value: 9,
        text: '09:00 Hours'
    }, */
    {
        value: 10,
        text: '10:00 Hours'
    },
/*     {
        value: 11,
        text: '11:00 Hours'
    }, */
    {
        value: 12,
        text: '12:00 Hours'
    },
/*     {
        value: 13,
        text: '13:00 Hours'
    }, */
    {
        value: 14,
        text: '14:00 Hours'
    },
/*     {
        value: 15,
        text: '15:00 Hours'
    }, */
    {
        value: 16,
        text: '16:00 Hours'
    },
/*     {
        value: 17,
        text: '17:00 Hours'
    }, */
    {
        value: 18,
        text: '18:00 Hours'
    },
/*     {
        value: 19,
        text: '19:00 Hours'
    }, */
    {
        value: 20,
        text: '20:00 Hours'
    },
/*     {
        value: 21,
        text: '21:00 Hours'
    }, */
    {
        value: 22,
        text: '22:00 Hours'
    },
/*     {
        value: 23,
        text: '23:00 Hours'
    }, */
];
const hourBasedEndOptions = [
/*     {
        value: 0,
        text: '00:59 Hours'
    }, */
    {
        value: 1,
        text: '01:59 Hours'
    },
/*     {
        value: 2,
        text: '02:59 Hours'
    }, */
    {
        value: 3,
        text: '03:59 Hours'
    },
/*     {
        value: 4,
        text: '04:59 Hours'
    }, */
    {
        value: 5,
        text: '05:59 Hours'
    },
/*     {
        value: 6,
        text: '06:59 Hours'
    }, */
    {
        value: 7,
        text: '07:59 Hours'
    },
/*     {
        value: 8,
        text: '08:59 Hours'
    }, */
    {
        value: 9,
        text: '09:59 Hours'
    },
/*     {
        value: 10,
        text: '10:59 Hours'
    } */,
    {
        value: 11,
        text: '11:59 Hours'
    },
 /*    {
        value: 12,
        text: '12:59 Hours'
    }, */
    {
        value: 13,
        text: '13:59 Hours'
    },
/*     {
        value: 14,
        text: '14:59 Hours'
    } */,
    {
        value: 15,
        text: '15:59 Hours'
    },
/*     {
        value: 16,
        text: '16:59 Hours'
    } */,
    {
        value: 17,
        text: '17:59 Hours'
    },
 /*    {
        value: 18,
        text: '18:59 Hours'
    }, */
    {
        value: 19,
        text: '19:59 Hours'
    },
/*     {
        value: 20,
        text: '20:59 Hours'
    } */,
    {
        value: 21,
        text: '21:59 Hours'
    },
 /*    {
        value: 22,
        text: '22:59 Hours'
    }, */
    {
        value: 23,
        text: '23:59 Hours'
    },
];

export {
    hourBasedStartOptions,
    hourBasedEndOptions
}